import { DataPointArray } from '@evorait/pace-core';
import { FUNCTIONAL_ELEMENT_TYPE, FunctionalElement } from './functional-element';

export type Signature = Readonly<{
    description: string; // description text to be displayed above the signature component
    label: string; // the text to be displayed as label for the signature pad
    entity: string; // XML entity referenced by this signature
    entityPath: string; // entire path to the image file in the publication package
    width: number; // width in pixel
    height: number; // height in pixel
    // nameField: Element, // the node in the XML DOM that represents the PDARESULT where the name needs to go
    signatureDataPoints: DataPointArray; // Array of DataPoints, used to reconstruct the signature after the signature was saved
    signature: string; // signature image represented as data URL; initially always empty as signing happens later
    date: string; // when was the signature given?
    dateXmlId: string; // the id of the XML element to update
    firstName: string; // redundant; needs to be kept in sync with participant copy when updating in reducer!
    lastName: string; // redundant; needs to be kept in sync with participant copy when updating in reducer!
    email: string; // redundant; needs to be kept in sync with participant copy when updating in reducer!
    emailRequired: boolean;
    nameXmlId: string; // the id of the xml element to update
    type:
        | FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_CUSTOMER
        | FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_EMPLOYEE
        | FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_CUSTOMER_SYSTEM_CONDITION
        | FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_EMPLOYEE_SYSTEM_CONDITION
        | FUNCTIONAL_ELEMENT_TYPE.EMPLOYEE_SIGNATURE
        | FUNCTIONAL_ELEMENT_TYPE.APPROVER_SIGNATURE;
}> &
    FunctionalElement;

export const initialSignature: Signature = {
    id: -1,
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_EMPLOYEE,
    signatureDataPoints: [],
    signature: '',
    entity: '',
    entityPath: '',
    description: '',
    label: '',
    height: -1,
    width: -1,
    date: '',
    dateXmlId: '',
    nameXmlId: '',
    firstName: '',
    lastName: '',
    email: '',
    emailRequired: true,
    controllingCheckpoint: '',
    contentLoadedFromXml: false,
    disabled: false,
    controllingOption: undefined,
    uniqueId: undefined,
};

export function isSignature(f: FunctionalElement): f is Signature {
    return (
        f.type === FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_EMPLOYEE ||
        f.type === FUNCTIONAL_ELEMENT_TYPE.SIGNOFF_CUSTOMER ||
        f.type === FUNCTIONAL_ELEMENT_TYPE.EMPLOYEE_SIGNATURE ||
        f.type === FUNCTIONAL_ELEMENT_TYPE.APPROVER_SIGNATURE
    );
}
